import { ReactNode, useMemo } from 'react'
import { useWallet } from '@solana/wallet-adapter-react'
import { useTheme } from 'next-themes'
import PlausibleProvider from 'next-plausible'

export const Telemetry = ({ children }: { children: ReactNode }) => {
  const { wallet } = useWallet()
  const { theme } = useTheme()

  const telemetryProps = useMemo(() => {
    const props = {
      walletProvider: wallet?.adapter.name ?? 'unknown',
      walletConnected: (wallet?.adapter.connected ?? 'false').toString(),
      currentTheme: theme ?? 'unknown',
    }

    // Hack to update script tag
    const el = document.getElementById('plausible')
    if (el) {
      Object.entries(props).forEach(([key, value]) => {
        el.setAttribute(`event-${key}`, value)
      })
    }

    return props
  }, [wallet?.adapter.name, wallet?.adapter.connected, theme])

  return (
    <PlausibleProvider
      domain="cabana.exchange"
      customDomain="https://pl.cabana-exchange.cloud"
      trackLocalhost={true}
      selfHosted={true}
      enabled={true}
      scriptProps={{ id: 'plausible' }}
      pageviewProps={telemetryProps}
    >
      {children}
    </PlausibleProvider>
  )
}
